import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import { pubCall } from "../utils/PubSub";

export default function Ping() {

    const [currentTime, setCurrentTime] = useState(dayjs());

    useEffect(() => {
        const intervalId = setInterval(() => {
            pubCall("extra.ping", { time: dayjs().unix() }, () => { });
            setCurrentTime(dayjs());
        }, 30000); // Update every second

        return () => clearInterval(intervalId); // Cleanup on unmount
    }, []);

    return (
        <></>
    );
}